// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2GlfM","productName":"Table_productName__3DFvt"};